let TimelineElements = [
  {
    id: 11,
    title: "Youth STEM & Activity Program Manager & Head Instructor",
    location: "Zebra Robotics",
    locationLink: "https://www.zebrarobotics.com/",
    date: "Sep 2025 - Present",
    icon: "work",
    description:
      "Lead structured after-school STEM, robotics, coding, and activity-based learning programs for children and youth ages 4-15. Design hands-on projects that strengthen students' problem-solving, teamwork, creativity, confidence, and logical thinking while adapting instruction, communication, and pacing to support diverse learning needs, inclusive participation, and social-emotional development. Supervise students and junior volunteers using clear expectations, calm redirection, positive behaviour support, and conflict-resolution strategies, while coordinating daily program logistics, material preparation, shared equipment care, attendance tracking, classroom organization, and family/staff communication to maintain a safe, inclusive, clean, and well-organized learning environment.",
  },
  {
    id: 1,
    title: "Part-Time, Computer Science",
    location: "Trinity Western University",
    date: "Sep 2024 - Apr 2025",
    icon: "school",
    description:
      "Attending Weekly TWU ICPC Meetings to practice problem-solving and coding for the ICPC coordinated by Andrew Park and Samuel Leung",
  },
  {
    id: 2,
    title: "Community Programs & Digital Systems Support",
    location: "Vancouver Persian Architects ",
    locationLink: "https://www.vpacommunity.ca/",
    description:
      "Supported a community-focused organization by designing and maintaining responsive digital platforms, organizing program information, updating schedules and announcements, and improving communication between participants, volunteers, and organizers. Collaborated with non-technical stakeholders to translate community and program needs into clear, accessible, and user-friendly online solutions.",
    date: "Jul 2024 - Dec 2024",
    icon: "work",
    buttonLink: "https://drive.google.com/file/d/16zyLz2RPhp_ohtxOUpEYtNFw0OWqqNNo/view?usp=sharing",
  },
  {
    id: 3,
    title: "Graduate Diploma, Software Engineering",
    location: "BrainStation",
    date: "Jan 2024 - Apr 2024",
    icon: "school",
    buttonText: "My Certificate",
    buttonLink: "https://drive.google.com/file/d/1iNEghSNJ49h0Km5IHxrmkj2PWpT7QnqF/view?usp=sharing",
  },
  {
    id: 4,
    title: "Customer Service & Operations Associate",
    location: "Sobeys - Thrifty Foods",
    locationLink: "https://www.thriftyfoods.com/find-a-store/store/9470-thrifty-foods-port-moody",
    description:
      "Provided consistent front-line customer service and operations support in a fast-paced retail environment. Assisted customers with transactions, inquiries, product navigation, and issue resolution while operating POS systems accurately, handling payments, supporting store organization, restocking products, and collaborating with team members to maintain efficient workflows and reliable service.",
    date: "Jan 2023 - Nov 2023",
    icon: "work",
    buttonLink: "https://drive.google.com/file/d/16zyLz2RPhp_ohtxOUpEYtNFw0OWqqNNo/view?usp=sharing",
  },
  {
    id: 5,
    title: "Human Resources & Administrative Assistant",
    location: "The Shining Sun Banquet Hall and Restaurant",
    locationLink: "https://www.instagram.com/ghasre.taban.aligudarz/",
    description:
      "Supported HR, administrative, and staff coordination tasks in a busy hospitality environment, including recruitment coordination, onboarding support, scheduling, employee records, document preparation, and staff communication. Handled sensitive information with professionalism, supported organized workplace processes, and assisted with social media communication to improve client engagement and brand visibility.",
    date: "Mar 2021 - Apr 2022",
    icon: "work",
  },
  {
    id: 6,
    title: "Customer Service Sales Specialist",
    location: "Peyk Saba Travel Company",
    locationLink: "https://www.payaneha.com/",
    description:
      "Supported customers in a fast-paced travel service environment by assisting with bookings, inquiries, itinerary changes, personalized recommendations, payment records, and follow-up communication. Helped maintain service continuity during the COVID-19 pandemic by supporting online sales, guiding customers through digital channels, providing multilingual support in English and Persian, and coordinating with clients, partners, and internal staff to resolve issues efficiently.",
    date: "May 2019 - May 2021",
    icon: "work",
  },
  {
    id: 7,
    title: "Youth & Family Support Assistant",
    location: "Mahak - International Society for Children with Cancer",
    locationLink: "https://iscc-charity.org/mahak-charity/",
    description:
      "Supported children, youth, and families in a pediatric hospital setting through supervised, psychology-informed emotional support, empathetic communication, appointment coordination, confidential documentation, and collaboration with healthcare and patient support teams. Helped create a calm, respectful, and organized care environment for families experiencing stress, while supporting play-based engagement and following established procedures.",
    date: "Apr 2019 - Apr 2021",
    icon: "work",
  },
  {
    id: 8,
    title: "Bachelor of Science, Psychology",
    location: "Bu-Ali Sina University",
    date: "Sep 2017 - Apr 2021",
    icon: "school",
    buttonText: "My Certificate",
    buttonLink: "https://drive.google.com/file/d/1az-R3H1IA4Lc4EIm0DZKJZszNQFECUEc/view?usp=sharing",
  },
  {
    id: 9,
    title: "Student Member, Robotics & Programming Team",
    location: "Farzanegan 1 High School Robotics Team",
    locationLink: "http://iranopenrobocup.ir/leagues/junior-rescue-maze-secondary",
    description:
      "Participated in a student robotics and programming team focused on search-and-rescue challenges, contributing to robot design, basic C++ programming, testing, maze navigation, obstacle avoidance, and competition preparation. This early experience built my foundation in robotics, teamwork, logical thinking, and technical problem-solving. The team earned 1st Place in the Junior Rescue League and 3rd Place in the Iran Open RoboCup Rescue League, 2014.",
    date: "Sep 2013 - Dec 2014",
    icon: "work",
  },
  {
    id: 10,
    title: "High School Diploma, Experimental Science",
    location: "Farzanegan 1 (Sampad)",
    date: "Sep 2012 - Jan 2017",
    icon: "school",
    buttonText: "My Certificate",
    buttonLink: "https://drive.google.com/file/d/16zyLz2RPhp_ohtxOUpEYtNFw0OWqqNNo/view?usp=sharing",
  },
];

export default TimelineElements;
